import React from 'react';
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

import css from './TitleMenuStatistics.module.css';
import {getTitleMenuStatistics} from "../../../helpers";


const TitleMenuStatistics = () => {
    const {t} = useTranslation();
    const listTitleMenu = getTitleMenuStatistics(t);


    return (
        <nav className={css.wrap}>
            <ul className={css.ul}>
                {listTitleMenu.map(({name, linkForRoute}) => (
                    <li key={name}>
                        <NavLink
                            to={`/statistics/${linkForRoute.toLowerCase()}`}
                            className={({isActive}) =>
                                `${css.menuItem} ${isActive ? css.active : ''}`
                            }
                        >
                            <span className={css.menuText}>{name}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export {TitleMenuStatistics};